import React from 'react';

import EmojiNeutralIcon from '@atlaskit/icon/core/emoji-neutral';

export const ToneNeutralIcon = () => (
	<EmojiNeutralIcon color="currentColor" label="" spacing="spacious" />
);
